"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KELVINISTS_POLICY_4 = exports.KELVINISTS_POLICY_3 = exports.KELVINISTS_POLICY_2 = exports.KELVINISTS_DEFAULT_POLICY = exports.KELVINISTS_BONUS_2 = exports.KELVINISTS_BONUS_1 = exports.Kelvinists = void 0;
const Party_1 = require("./Party");
const PartyName_1 = require("./PartyName");
const Resources_1 = require("../../Resources");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const TurmoilPolicy_1 = require("../TurmoilPolicy");
const constants_1 = require("../../constants");
const KelvinistsDefaultAction_1 = require("../../cards/turmoil/standardActions/KelvinistsDefaultAction");
const KelvinistsPolicy3Action_1 = require("../../cards/turmoil/standardActions/KelvinistsPolicy3Action");
class Kelvinists extends Party_1.Party {
    constructor() {
        super(...arguments);
        this.name = PartyName_1.PartyName.KELVINISTS;
        this.description = 'Pushes for rapid terraforming, usually employing a heat-first strategy.';
        this.bonuses = [exports.KELVINISTS_BONUS_1, exports.KELVINISTS_BONUS_2];
        this.policies = [exports.KELVINISTS_DEFAULT_POLICY, exports.KELVINISTS_POLICY_2, exports.KELVINISTS_POLICY_3, exports.KELVINISTS_POLICY_4];
    }
}
exports.Kelvinists = Kelvinists;
class KelvinistsBonus01 {
    constructor() {
        this.id = 'kb01';
        this.isDefault = true;
        this.description = 'Gain 1 M€ for each Heat production you have';
    }
    getScore(player) {
        return player.getProduction(Resources_1.Resources.HEAT);
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class KelvinistsBonus02 {
    constructor() {
        this.id = 'kb02';
        this.description = 'Gain 1 heat for each Heat production you have';
        this.isDefault = false;
    }
    getScore(player) {
        return player.getProduction(Resources_1.Resources.HEAT);
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.HEAT, this.getScore(player));
        });
    }
}
class KelvinistsPolicy01 {
    constructor() {
        this.isDefault = true;
        this.id = TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_DEFAULT_POLICY;
        this.description = 'Pay 10 M€ to increase your Energy and Heat production 1 step';
    }
    canAct(player) {
        return player.canAfford(10);
    }
    action(player) {
        const game = player.game;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new KelvinistsDefaultAction_1.KelvinistsDefaultAction()));
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 10, {
            title: 'Select how to pay for Turmoil Kelvinists action',
            afterPay: () => {
                player.addProduction(Resources_1.Resources.ENERGY, 1);
                player.addProduction(Resources_1.Resources.HEAT, 1);
                game.log('${0} increased heat and energy production 1 step', (b) => b.player(player));
            },
        }));
        return undefined;
    }
}
class KelvinistsPolicy02 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_2;
        this.description = 'When you raise temperature, gain 3 M€ per step raised';
        this.isDefault = false;
    }
}
class KelvinistsPolicy03 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_3;
        this.description = 'Convert 6 heat into temperature';
        this.isDefault = false;
    }
    canAct(player) {
        return player.availableHeat >= 6 && player.game.getTemperature() < constants_1.MAX_TEMPERATURE;
    }
    action(player) {
        const game = player.game;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new KelvinistsPolicy3Action_1.KelvinistsPolicy3Action()));
        game.log('${0} spent 6 heat to raise temperature 1 step', (b) => b.player(player));
        return player.spendHeat(6, () => {
            game.increaseTemperature(player, 1);
            return undefined;
        });
    }
}
class KelvinistsPolicy04 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_4;
        this.description = 'When you place a tile, gain 2 heat';
        this.isDefault = false;
    }
    onTilePlaced(player) {
        player.addResource(Resources_1.Resources.HEAT, 2);
    }
}
exports.KELVINISTS_BONUS_1 = new KelvinistsBonus01();
exports.KELVINISTS_BONUS_2 = new KelvinistsBonus02();
exports.KELVINISTS_DEFAULT_POLICY = new KelvinistsPolicy01();
exports.KELVINISTS_POLICY_2 = new KelvinistsPolicy02();
exports.KELVINISTS_POLICY_3 = new KelvinistsPolicy03();
exports.KELVINISTS_POLICY_4 = new KelvinistsPolicy04();
//# sourceMappingURL=Kelvinists.js.map